import type { ReactNode } from 'react';
import clsx from 'clsx';

export interface BadgeProps {
  children: ReactNode;
  variant?: 'reminder' | 'email' | 'warning' | 'success' | 'info' | 'error' | 'primary' | 'default';
  className?: string;
  title?: string;
  onClick?: (e: React.MouseEvent) => void;
}

export function Badge({ children, variant = 'info', className, title, onClick }: BadgeProps) {
  const variantClasses = {
    reminder: 'badge-reminder',
    email: 'badge-email',
    warning: 'badge-warning',
    success: 'bg-green-900 text-green-300',
    info: 'bg-blue-900 text-blue-300',
    error: 'bg-red-900 text-red-300',
    primary: 'bg-primary-900 text-primary-300',
    default: 'bg-dark-elevated text-dark-text-secondary',
  };

  return (
    <span className={clsx('badge', variantClasses[variant], className)} title={title} onClick={onClick}>
      {children}
    </span>
  );
}
